function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var genFormValidateMotionStyle = function genFormValidateMotionStyle(token) {
  var _helpItemCls;

  var componentCls = token.componentCls;
  var helpCls = "".concat(componentCls, "-show-help");
  var helpItemCls = "".concat(componentCls, "-show-help-item");
  return _defineProperty({}, helpCls, _defineProperty({
    // Explain holder
    transition: "opacity ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut),
    '&-appear, &-enter': {
      opacity: 0,
      '&-active': {
        opacity: 1
      }
    },
    '&-leave': {
      opacity: 1,
      '&-active': {
        opacity: 0
      }
    }
  }, helpItemCls, (_helpItemCls = {
    overflow: 'hidden',
    transition: "height ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, ",\n                     opacity ").concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, ",\n                     transform ").concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, " !important")
  }, _defineProperty(_helpItemCls, "&".concat(helpItemCls, "-appear, &").concat(helpItemCls, "-enter"), _defineProperty({
    transform: "translateY(-5px)",
    opacity: 0
  }, "&-active", {
    transform: 'translateY(0)',
    opacity: 1
  })), _defineProperty(_helpItemCls, "&".concat(helpItemCls, "-leave-active"), {
    transform: "translateY(-5px)"
  }), _helpItemCls)));
};

export default genFormValidateMotionStyle;